// @flow
import { ProcedenciasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    procedencia: {},
    listaProcedencias: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type ProcedenciasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { procedencia?: {} | null, listaProcedencias?: [] | null, loading?: boolean, +value ?: boolean };

const Procedencias = (state: State = INIT_STATE, action: ProcedenciasAction): any => {
    // console.log(action);
    switch (action.type) {
        case ProcedenciasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ProcedenciasActionTypes.GET_PROCEDENCIA: {
                    return {
                        ...state,
                        procedencia: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ProcedenciasActionTypes.LIST_PROCEDENCIAS: {
                    return {
                        ...state,
                        listaProcedencias: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ProcedenciasActionTypes.ADD_PROCEDENCIA: {
                    return {
                        ...state,
                        procedencia: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ProcedenciasActionTypes.UPDATE_PROCEDENCIA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ProcedenciasActionTypes.DELETE_PROCEDENCIA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ProcedenciasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ProcedenciasActionTypes.GET_PROCEDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        procedencia: {},
                        loading: false,
                    };
                }
                case ProcedenciasActionTypes.LIST_PROCEDENCIAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaProcedencias: [],
                        loading: false,
                    };
                }
                case ProcedenciasActionTypes.ADD_PROCEDENCIA: {
                    return {
                        ...state,
                        procedencia: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ProcedenciasActionTypes.UPDATE_PROCEDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ProcedenciasActionTypes.DELETE_PROCEDENCIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ProcedenciasActionTypes.GET_PROCEDENCIA:
            return { ...state, error: false, loading: true };
        case ProcedenciasActionTypes.LIST_PROCEDENCIAS:
            return { ...state, error: false, loading: true };
        case ProcedenciasActionTypes.ADD_PROCEDENCIA:
            return { ...state, error: false, loading: true };
        case ProcedenciasActionTypes.UPDATE_PROCEDENCIA:
            return { ...state, error: false, loading: true };
        case ProcedenciasActionTypes.DELETE_PROCEDENCIA:
            return { ...state, error: false, loading: true };
        case ProcedenciasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                procedencia: {},
                listaProcedencias: [],
                formSubmited: false
            };
        case ProcedenciasActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Procedencias;
